module.exports = {"450305001":"七星区街道","450305002":"东江街道","450305003":"穿山街道","450305004":"漓东街道","450305200":"朝阳乡","450305400":"桂林华侨旅游经济区管理委员会"}


//////////////////
// WEBPACK FOOTER
// ./src/town/450305.json
// module id = 1921
// module chunks = 0